import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog/PerformanceServerTiming errors (third-party, not app-related)
// This prevents the React error overlay from showing for these specific errors
const suppressedErrors = ['postMessage', 'PerformanceServerTiming', 'posthog', 'DataCloneError', 'SecurityError', 'cross-origin'];

// Block CRA dev error overlay for suppressed errors
if (process.env.NODE_ENV === 'development') {
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    const msg = String(message || '') + String(error?.message || '') + String(source || '');
    if (suppressedErrors.some(err => msg.toLowerCase().includes(err.toLowerCase()))) {
      return true;
    }
    return originalOnError ? originalOnError(message, source, lineno, colno, error) : false;
  };
}

window.addEventListener('error', (event) => {
  const msg = String(event.message || '') + String(event.error?.message || '') + String(event.filename || '');
  if (suppressedErrors.some(err => msg.toLowerCase().includes(err.toLowerCase()))) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message || '') + String(event.reason || '');
  if (suppressedErrors.some(err => msg.toLowerCase().includes(err.toLowerCase()))) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true);

// Also suppress console errors for these
const originalError = console.error;
console.error = (...args) => {
  const errorString = args.join(' ');
  if (suppressedErrors.some(err => errorString.includes(err))) {
    return;
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
